/**
 * Признак автоматизированной сессии — e2e-прогона, а не живого пользователя.
 *
 * Playwright-тесты (`playwrightFrontendTests`) по умолчанию гоняются по проду
 * (`E2E_TARGET=prod` → https://spb.farkop.ru): они листают каталог, кладут
 * товары в корзину и доводят заказ до конца. Без этой отсечки каждый прогон
 * накручивает цели и электронную коммерцию в Метрике.
 *
 * Основной признак — `navigator.webdriver`: его выставляют Playwright,
 * Puppeteer и Selenium, и он не требует правок в самих тестах. Дополнительно
 * поддерживаются явные маркеры на случай, если браузер запущен с подменой
 * webdriver:
 *  - `?e2e=1` в адресе (запоминается на сессию);
 *  - `window.__E2E__ = true` (например, через `page.addInitScript`);
 *  - cookie `e2e=1`.
 */
import { safeSessionStorage } from "../safeStorage";

const MARKER_KEY = "isE2E";

function hasQueryMarker(): boolean {
  try {
    return new URLSearchParams(window.location.search).get("e2e") === "1";
  } catch {
    return false;
  }
}

function hasCookieMarker(): boolean {
  try {
    return document.cookie.includes("e2e=1");
  } catch {
    return false;
  }
}

export function isAutomatedSession(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }
  try {
    if (safeSessionStorage.getItem(MARKER_KEY) === "1") {
      return true;
    }
    const isAutomated =
      navigator.webdriver === true ||
      // eslint-disable-next-line no-underscore-dangle
      (window as any).__E2E__ === true ||
      hasQueryMarker() ||
      hasCookieMarker();

    if (isAutomated) {
      // Метка на всю сессию: переходы по сайту теряют ?e2e=1, а признак должен
      // сохраниться до конца прогона.
      safeSessionStorage.setItem(MARKER_KEY, "1");
    }
    return isAutomated;
  } catch (e) {
    console.log("isAutomatedSession error", e);
    return false;
  }
}
